import { useContext } from "react";
import { AppContext } from "../App";
import { currencyFormat } from "./functions";
import Label from "./Label";
import PlusMinus from "./PlusMinus";
import { useNavigate } from "react-router-dom";
import PromoLevels from "./PromoLevels";
import PromoBanner from "./PromoBanner";

function sortModifiers(items = []) {
  return [...items].sort((a, b) => {
    const aIsIngredientZero = a.qty === 0 && Number(a.is_ingredients) === 1;
    const bIsIngredientZero = b.qty === 0 && Number(b.is_ingredients) === 1;
    if (aIsIngredientZero && !bIsIngredientZero) return -1;
    if (!aIsIngredientZero && bIsIngredientZero) return 1;
    return 0;
  });
}

function ModifierLine({ item }) {
  if (item.qty === undefined) return null;
  if (item.qty === 0 && Number(item.is_ingredients) !== 1) return null;

  const label = Number(item.is_ingredients) === 1 && Number(item.qty) === 0 ? "No " : item.qty + "x ";
  return <div className={Number(item.qty) <= 0 ? "text-error" : ""}>{label + item.name}</div>;
}

function Cart({ cartEnabled, setCartEnabled }) {
  const { cart, handleEditProduct, user, setLoginPopup, emptyCart, track } = useContext(AppContext);
  const navigate = useNavigate();
  const isCapacityFull = cart.slot_invalidation?.code == "capacity_full";

  const toggleCart = (mode) => {
    const el = document.getElementById("cart");
    if (mode) {
      el.style.display = "flex";
      el.style.flexDirection = "column";
    } else {
      el.style.display = null;
      el.style.flexDirection = null;
    }
  };

  if (!cart) return null;

  const handleOrder = () => {
    if (!cartEnabled) setCartEnabled(true);
    else if (!user) setLoginPopup(true);
    else {
      navigate("/checkout");
      track();
    }
  };

  return (
    <>
      <div id="cart">
        <div className="close-button">
          <button onClick={() => toggleCart(false)}>x</button>
        </div>
        <PromoBanner />
        <div className="container">
          <PromoLevels />
          <div className="content">
            <div className="title">
              <Label number={23} />
            </div>
            {cart.products.map((product, i) => (
              <div key={i} className="line">
                <div>
                  {product.name}
                  <div className="small smoot">
                    {sortModifiers(product.variants).map((variant, i) => (
                      <ModifierLine key={"v-" + i} item={variant} />
                    ))}
                    {sortModifiers(product.products || []).map((subproduct, i) => (
                      <ModifierLine key={"p-" + i} item={subproduct} />
                    ))}
                    {product.notes && <div dangerouslySetInnerHTML={{ __html: product.notes }} />}
                  </div>
                </div>
                <div>
                  {product.is_removable != 0 && (
                    <PlusMinus
                      qty={product.qty}
                      onCange={(qty) => handleEditProduct(product, qty)}
                      qtyValue={product.qty_unsplitted ? product.qty_unsplitted : product.qty}
                    />
                  )}
                </div>
                <div>
                  {product.discounted == 1 ? (
                    <div>
                      <span className="small smoot">
                        <s>{currencyFormat(product?.original_price, cart?.shop?.currency)}</s>{" "}
                      </span>
                      {currencyFormat(product.total, cart?.shop?.currency)}
                    </div>
                  ) : (
                    <div>{currencyFormat(product.total, cart?.shop?.currency)}</div>
                  )}
                </div>
              </div>
            ))}
            {cart.discounts_code?.length > 0 &&
              cart.discounts_code.map((discount, i) => (
                <div
                  key={i}
                  className={"line-separator discount-line " + (discount.enabled == 1 ? "" : "disabled")}
                >
                  <div className="line subtotal">
                    <div>
                      <Label number={13} />
                    </div>
                    <div></div>
                    <div>{currencyFormat(discount.total_before_discount, cart?.shop?.currency)}</div>
                  </div>
                  <div className={"line-discount " + (discount.enabled == 1 ? "" : "disabled")}>
                    <div className="icon">{discount.name}</div>
                    <div>
                      {discount.is_supplement ? "" : "-"}
                      {currencyFormat(Math.abs(discount.price), cart?.shop?.currency)}
                    </div>
                  </div>
                </div>
              ))}
            {cart.delivery_type == "delivery" && (
              <>
                <div className="line subtotal">
                  <div>
                    <Label number={13} />
                  </div>
                  <div></div>
                  <div>{currencyFormat(cart.total_before_delivery_price, cart?.shop?.currency)}</div>
                </div>
                <div className="line">
                  <div>
                    <Label number={14} />
                  </div>
                  <div></div>
                  <div>{currencyFormat(cart.delivery_price, cart?.shop?.currency)}</div>
                </div>
              </>
            )}
            <div className="line-separator">
              <div className="line total">
                <div>
                  <Label number={15} />
                </div>
                <div></div>
                <div>{currencyFormat(cart.total, cart?.shop?.currency)}</div>
              </div>
            </div>
            {cart.order_min && cart.order_min > 0 && (
              <div className="line small">
                <div>
                  <Label number={166} />
                </div>
                <div></div>
                <div>{currencyFormat(cart.order_min, cart?.shop?.currency)}</div>
              </div>
            )}
            {cart.delivery_type == "delivery" && cart.delivery_free_min && cart.delivery_free_min > 0 && (
              <div className="line small">
                <div>
                  <Label number={167} />
                </div>
                <div></div>
                <div>{currencyFormat(cart.delivery_free_min, cart?.shop?.currency)}</div>
              </div>
            )}
          </div>
          <div className="footer">
            {isCapacityFull ? (
              <div className="cart-alert cart-alert-error mb-2" role="alert">
                <Label number={219} />
              </div>
            ) : (
              <button
                className="button button-primary button-block mb-2"
                onClick={handleOrder}
              >
                <Label number={16} />
              </button>
            )}
            <button className="button button-secondary button-block" onClick={() => emptyCart()}>
              <Label number={173} />
            </button>
          </div>
        </div>
      </div>
      <div className="checkout-fixed">
        <div className="checkout-fixed-main">
          <div className="checkout-total">Totale: {currencyFormat(cart.total, cart?.shop?.currency)}</div>
          <button className="checkout-order-button" onClick={() => toggleCart(true)}>
            ORDINA
          </button>
        </div>
      </div>
    </>
  );
}

export default Cart;
